import { ref, get } from "firebase/database";
import { database } from "../../../../Utils/firebase";

const GetAssignerUserSaleReturnDataInFirebase = async (state, dispatch, sharedBusinesses = null) => {
    const owners = sharedBusinesses || state?.ASSIGNERUSERBUSINESSES || [];

    if (!owners.length) return [];

    try {
        const sharedInvoices = [];

        const ownerPromises = owners.map(async (owner) => {
            const ownerUid = owner.ownerUid;
            const companies = owner.companies || [];

            // Gather all allowed company IDs for this specific owner
            const allowedCompanyIds = companies.map(company => company.companyId || company.businessId || company.id);

            if (!allowedCompanyIds.length) return;

            const invoiceRef = ref(
                database,
                `invoiceGenerator/users/${ownerUid}/returnInvoice`
            );

            const snapshot = await get(invoiceRef);

            if (!snapshot.exists()) return;

            const invoices = snapshot.val();

            Object.entries(invoices).forEach(([invoiceId, invoiceData]) => {
                // Ensure we only include items for the specific shared companies
                if (allowedCompanyIds.includes(invoiceData.companyId) && !invoiceData.isDeleted) {
                    sharedInvoices.push({
                        uniqueID: invoiceId,
                        ownerUid,
                        ...invoiceData,
                        isShared: true
                    });
                }
            });
        });

        await Promise.all(ownerPromises);

        return sharedInvoices;

    } catch (error) {
        console.error("Firebase SaleReturn Fetch Error:", error);
        return [];
    }
};

export default GetAssignerUserSaleReturnDataInFirebase;
